import React from "react";
import styles from "./MessageActionMenu.module.scss";
import { Spin } from "@douyinfe/semi-ui";
import Locale from "@/app/locales";
import { MessageSender } from "@/app/store/types";

interface MessageActionMenuProps {
  onWithdraw: () => void;
  loading: boolean;
  onQuoted: () => void;
  onCopy: () => void;
  sender: MessageSender;
  canWithdraw: () => boolean | null;
}

const MessageActionMenu: React.FC<MessageActionMenuProps> = ({
  onWithdraw,
  canWithdraw,
  loading,
  onQuoted,
  sender,
  onCopy,
}) => {
  return (
    <div
      className={`${sender === MessageSender.USER ? styles.users : styles.agentOrSystem} ${styles.messageActionMenu}`}
      style={{
        position: "absolute",
        zIndex: 1000,
      }}
    >
      <div className={styles.menuContent}>
        <div className={styles.triangle}></div>
        {/* 只有发送成功的消息才能撤回 */}
        {canWithdraw() && (
          <button className={styles.menuButton} onClick={onWithdraw}>
            {loading ? (
              <>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <Spin size="small" style={{ marginRight: "4px" }} />{" "}
                  {Locale.chat.withdrawing}
                </span>
              </>
            ) : (
              Locale.chat.withdraw
            )}
          </button>
        )}
        <button className={styles.menuButton} onClick={onQuoted}>
          {Locale.chat.quotedMessage}
        </button>
        <button className={styles.menuButton} onClick={onCopy}>
          {Locale.chat.copy}
        </button>
      </div>
    </div>
  );
};

export default MessageActionMenu;
